import styled from 'styled-components';
import {device} from 'styled/device';
import Button from '../common/Button';
import Loading from '../common/Loading';

export const ButtonConfirm = styled(Button)`
  margin-top: 30px;
  max-width: none;
`;
export const Error = styled.div`
  align-self: baseline;
`;

type ContentProps = {
  isLoading?: boolean;
};

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  height: ${props => (props.isLoading ? '110px' : 'auto')};
  transition: opacity 0.3s ease-in-out;
  width: 100%;

  .loading-spinner {
    @media (min-width: ${device.tablet}) {
      margin-top: 25px;
      padding: 0;
    }
  }

  @media (min-width: ${device.tablet}) {
    padding: 0;
  }
`;

export const ErrorContainer = styled.div``;
export const ErrorMessage = styled.div`
  font-family: inherit;
  text-align: left;
  color: #f84b7a;
  font-size: 11px;
`;

export const StyledLoader = styled(Loading)`
  margin-top: 20px;

  @media (max-width: ${device.mobileXL}) {
    margin-top: 25px;
    svg {
      width: 70px;
    }
  }
`;
